/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * An enumeration of different Http status codes.
 * Following this pattern since we need runtime support of
 * the values of the enum.
 * Tip #4: https://medium.com/@martin_hotell/10-typescript-pro-tips-patterns-with-or-without-react-5799488d6680
 */
type EnumLiteralOf<T extends object> = T[keyof T];

export const HttpStatusCode = Object.freeze({
  Ok: 200 as 200,
  CreatedAt: 201 as 201,
  NoContent: 204 as 204,
  BadRequest: 400 as 400,
  Unauthorized: 401 as 401,
  Forbidden: 403 as 403,
  NotFound: 404 as 404,
  ServerError: 500 as 500,
  NotImplemented: 501 as 501,
  BadGateway: 502 as 502,
  ServiceNotAvailable: 503 as 503,
});

export type HttpStatusCode = EnumLiteralOf<typeof HttpStatusCode>;
